import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import { DatePropType } from './helpers/common';

/**
 * Calendar popover Day cell component
 */
const DayCell = ({
  className,
  onMouseOver,
  date,
  getDateProps,
  dateObj,
  tooltipContent,
  tooltipContainer
}) => {
  const onOver = () => {
    onMouseOver && onMouseOver(date);
  };

  const containerProps = {
    ...getDateProps({
      dateObj,
      onMouseOver: onOver,
      className,
      'data-testid': `DayCell__year-${date.getFullYear()}__month-${date.getMonth()}__day-${date.getDate()}`
    })
  };

  const children = (
    <>
      <div className="DayCell__background" />
      <div className="DayCell__value">{date.getDate()}</div>
    </>
  );

  return tooltipContent ? (
    <Tooltip
      tooltipClassName="DayCell__tooltip"
      getTargetProps={() => containerProps}
      theme={Tooltip.Themes.DARK}
      place={Tooltip.Places.TOP}
      content={tooltipContent}
      container={tooltipContainer}
    >
      {children}
    </Tooltip>
  ) : (
    <div {...containerProps}>{children}</div>
  );
};

DayCell.propTypes = {
  /**
   * the date cell css class name
   */
  className: PropTypes.string,
  /**
   * callback to be called when the cell is hovered
   */
  onMouseOver: PropTypes.func,
  /**
   * the date object respective to the cell
   */
  date: DatePropType,
  /**
   * the Dayzed getDateProps func
   */
  getDateProps: PropTypes.func,
  /**
   * the dateObj param for the getDateProps function
   */
  dateObj: PropTypes.object,
  /**
   * the tooltip content for the cell
   */
  tooltipContent: PropTypes.node,
  /**
   * the tooltip container for the cell
   */
  tooltipContainer: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default DayCell;
